/*========================================================================
* $Id: list.js 124298 2018-01-15 14:43:10Z erhard.einsiedler $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define({
  
  merge: function (obj1, obj2) {
    var mergedObject = {};
  
    // Function to merge properties of two objects
    function mergeProperties(target, source) {
      var keys = Object.keys(source);
      
      for (var i = 0; i < Object.keys(source).length; i++) {
        var key = Object.keys(source)[i];
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          if (typeof source[key] === 'object' && !Array.isArray(source[key])) {
            // If the property is an object (but not an array), recursively merge it
            target[key] = mergeProperties(target[key] || {}, source[key]);
          } else if (Array.isArray(source[key]) && Array.isArray(target[key])) {
            // If both properties are arrays, concatenate them
            target[key] = target[key].concat(source[key]);
          }  else {
            // Otherwise, assign the property value directly
            target[key] = source[key];
          }
        }
      }
      return target;
    }
  
    // Merge properties from both objects
    mergeProperties(mergedObject, obj1);
    mergeProperties(mergedObject, obj2);
  
    return mergedObject;
  }

});
